// GET_LIMITED_CHECK_IN
export const GET_CHECK_IN_REQUEST = "GET_CHECK_IN_REQUEST";
export const GET_CHECK_IN_SUCCESS = "GET_CHECK_IN_SUCCESS";
export const GET_CHECK_IN_FAIL = "GET_CHECK_IN_FAIL";
